module.exports = "<!-- Navigation -->\n<app-navbar></app-navbar>\n\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main